import { LooseCargoTypeEnum } from '@zen/types';
import type { Nullable } from '@zen/utils/typescript';

export type Container = {
  description: string;
  hsCodes: string[];
  id: string;
  loose: {
    grossWeight: { metric: string; value: Nullable<number> };
    quantity: Nullable<number>;
    type: Nullable<LooseCargoTypeEnum>;
    volume: Nullable<number>;
  };
  marksAndNumbers: string;
  number: string;
  packagingTypes: string;
  sealNumber: string;
  size: string;
};

export const emptyContainer: Container = {
  id: '',
  description: '',
  hsCodes: [],
  loose: {
    grossWeight: { metric: 'KG', value: null },
    quantity: null,
    type: null,
    volume: null
  },
  marksAndNumbers: '',
  number: '',
  packagingTypes: '',
  sealNumber: '',
  size: ''
};

export type RawContainer = Omit<Container, 'hsCodes'> & {
  hsCodes: string | string[];
};
